import React, {
    FunctionComponent,
    useContext,
    useMemo,
    useEffect,
    useLayoutEffect,
    useState,
    useCallback,
} from "react";
import ReactDOM from "react-dom";
import NavBar from "@Components/article/superTest/navBar";
import Right from "@Components/article/superTest/right";
import FixedTable from "@Components/article/superTest/table/fixedTable";
import FillTable from "@Components/article/superTest/table/fillTable";
import { chartColorArr } from "@Components/article/superTest/chart/const";
import Bar from "@Components/article/superTest/chart/bar";
import BarGroup from "@Components/article/superTest/chart/barGroup";
import HorizontalBar from "@Components/article/superTest/chart/horizontalBar";
import { host } from "@Services/url";
import HorizontalBarGroup from "@Components/article/superTest/chart/horizontalBarGroup";
import ChartExtraBar from "@Components/article/superTest/chart/chartExtraBar";
import Speedways from "@Components/article/superTest/speedways/index";
import BrakeCard from "@Components/article/superTest/kindCard/brakeCard";
import EnergyCard from "@Components/article/superTest/kindCard/energyConsumption";
import ShakeLine from "@Components/article/superTest/shakeLine";
import SupertestTab from "@Components/article/superTest/tab/index";
import FixedRank from "@Components/article/superTest/fixedRank";
import Compare from "@Components/article/superTest/compare";
import Provider, {
    Context,
    ICharts,
    horizontalBarType,
} from "@Components/article/superTest/context";
import {
    WrapperProvider,
    WrapperContext,
    ObserverWrapper,
} from "@Components/article/superTest/observerLayout";

import { initTitle } from "./init";
import styles from "./index.module.less";
import "./index.less";
import cx from "classnames";

const Layout = ({ Comp }) => {
    // const contentProps = useContext(Context);
    const props = useContext(WrapperContext);

    return <Comp {...props} />;
};

const CommonWrapper = ({ Comp }) => {
    return (
        <WrapperProvider>
            {/* <Provider> */}
            <Layout Comp={Comp}></Layout>
            {/* </Provider> */}
        </WrapperProvider>
    );
};

const EmptyComp = () => {
    return <></>;
};

const validateData = (data: any, key: number) => {
    if (
        data?.[key] &&
        data?.[key]?.chartData &&
        data?.[key]?.chartData.length !== 0
    ) {
        return data?.[key] as ICharts;
    }
    return false;
};

const Content: FunctionComponent = () => {
    const {
        charts,
        chartMapData,
        kindData,
        shockData,
        setCompare,
        compareMyid,
    } = useContext(Context);
    const [current, setCurrent] = useState<string>("");
    const [keys, setKeys] = useState<any>({});

    const setSuperTestKey = (key: string) => {
        if (key && current !== key && !(key in keys)) {
            setKeys((prev) => ({ ...prev, [key]: key }));
            setCurrent(key);
        }
    };

    // 1 車系編成
    const CarCompiledDom = useMemo(() => {
        const res = validateData(chartMapData, 1) as ICharts | false;
        if (res) {
            return <FixedTable title="車系編成" dataSource={res} />;
        }

        return <EmptyComp />;
    }, [chartMapData]);

    const insertCar = () => {
        if (validateData(chartMapData, 1)) {
            const $app = document.getElementById("supertable-car");

            !!$app && ReactDOM.render(CarCompiledDom, $app);
        }
    };

    // 2 內外設計
    const CarDesignDom = useMemo(() => {
        const res = validateData(chartMapData, 2) as ICharts | false;

        if (res) {
            return <FillTable tableType="fillTable" dataSource={res} />;
        }

        return <EmptyComp />;
    }, [chartMapData]);

    const insertDesign = () => {
        if (validateData(chartMapData, 2)) {
            const $app = document.getElementById("supertable-design");

            !!$app && ReactDOM.render(CarDesignDom, $app);
        }
    };

    // 3 駕駛輔助系統差異表
    const CarADASDom = useMemo(() => {
        const res = validateData(chartMapData, 3) as ICharts | false;

        if (res) {
            return <FixedTable title="駕駛輔助系統差異表" dataSource={res} />;
        }

        return <EmptyComp />;
    }, [chartMapData]);

    const insertADAS = () => {
        if (validateData(chartMapData, 3)) {
            const $app = document.getElementById("supertable-driver");

            !!$app && ReactDOM.render(CarADASDom, $app);
        }
    };

    // 4 空間測量
    const CarSpaceDom = useMemo(() => {
        const res = validateData(chartMapData, 4) as ICharts | false;

        if (res) {
            return <FillTable tableType="fillHeader" dataSource={res} />;
        }

        return <EmptyComp />;
    }, [chartMapData]);

    const insertSpace = () => {
        if (validateData(chartMapData, 4)) {
            const $app = document.getElementById("supertable-space");

            !!$app && ReactDOM.render(CarSpaceDom, $app);
        }
    };
    

    // 9 座椅乘坐感
    const CarSpaceImgDom = useMemo(() => {
        const res = validateData(chartMapData, 5) as ICharts | false;

        if (res) {
            return <SupertestTab charts={charts} dataSource={res.chartData} />;
        }

        return <EmptyComp />;
    }, [chartMapData]);

    const insertSpaceImg = () => {
        if (validateData(chartMapData, 5)) {
            const $app = document.getElementById("supertable-space-img");

            !!$app && ReactDOM.render(CarSpaceImgDom, $app);
        }
    };

    // 6 舒适性测试
    const CarComfortDom = useMemo(() => {
        const res = validateData(chartMapData, 6) as ICharts | false;

        if (res) {
            return <FillTable tableType="fillHeader" dataSource={res} />;
        }

        return <EmptyComp />;
    }, [chartMapData]);

    const insertComfort = () => {
        if (validateData(chartMapData, 6)) {
            const $app = document.getElementById("supertable-comfort");

            !!$app && ReactDOM.render(CarComfortDom, $app);
        }
    };

    // 13 耗能测试
    const CarEnergyDom = () => {
        const res = validateData(chartMapData, 13) as ICharts | false;
        const data = kindData?.["energyConsumption"];
        const [upKeys, setUpKeys] = useState<string[]>([]);

        if (res && data && data.length !== 0) {
            const { kindInfo } = kindData;
            const titles = [
                ["product"].concat(kindInfo.map((item) => item.title)),
            ];
            const dataSource = res.chartData.map((item) => [
                item.title,
                ...item.value.map((item) => Number(item)),
            ]);

            return (
                <div className={"supertest-observer"}>
                    {res.chartName && (
                        <div className={styles["bar-title"]}>
                            {res.chartName}
                        </div>
                    )}
                    <ObserverWrapper
                        name="cityFuelConsumption"
                        observerCallBack={(key) => setSuperTestKey(key)}
                        observerOnceCallBack={(key) =>
                            setUpKeys((prev) =>
                                !prev.includes(key) ? prev.concat(key) : []
                            )
                        }
                    >
                        <HorizontalBarGroup
                            id="cityFuelConsumption"
                            name={res.chartName}
                            width={786}
                            height={384}
                            dataSource={titles.concat(dataSource as any)}
                            visibleKeys={upKeys}
                        />
                    </ObserverWrapper>
                    <EnergyCard dataSource={data} />
                </div>
            );
        }

        return <EmptyComp />;
    };

    const insertEnergy = () => {
        if (validateData(chartMapData, 13)) {
            const $app = document.getElementById("supertable-energy");

            !!$app &&
                ReactDOM.render(
                    <CommonWrapper Comp={CarEnergyDom}></CommonWrapper>,
                    $app
                );
        }
    };

    // 8 車室隔音對照表
    const CarSoundproofingDom = () => {
        const res = validateData(chartMapData, 8) as ICharts | false;
        const [upKeys, setUpKeys] = useState<string[]>([]);

        if (res) {
            const { kindInfo } = kindData;
            const titles = [
                ["product"].concat(kindInfo.map((item) => item.title)),
            ];
            const dataSource = res.chartData.map((item) => [
                item.title,
                ...item.value.map((item) => Number(item)),
            ]);
            const extraKeys = (res.chartData as horizontalBarType[])[0]?.key;
            const extraDataArr = extraKeys.map((item, inx) => {
                const data = kindInfo.filter((i) => i.myid === item)?.[0];

                return data
                    ? {
                          name: data.title,
                          value: data.environment,
                          color: chartColorArr[inx],
                      }
                    : { name: "", value: "", color: chartColorArr[0] };
            });

            return (
                <div className={"supertest-observer"}>
                    {res.chartName && (
                        <div className={styles["bar-title"]}>
                            {res.chartName}
                        </div>
                    )}
                    <ObserverWrapper
                        name="sound-proofing-chart"
                        observerCallBack={(key) => setSuperTestKey(key)}
                        observerOnceCallBack={(key) =>
                            setUpKeys((prev) =>
                                !prev.includes(key) ? prev.concat(key) : prev
                            )
                        }
                    >
                        <BarGroup
                            id="sound-proofing-chart"
                            width={786}
                            height={372}
                            dataSource={titles.concat(dataSource as any)}
                            visibleKeys={upKeys}
                        />
                    </ObserverWrapper>
                    <ChartExtraBar dataSource={extraDataArr} />
                </div>
            );
        }

        return <EmptyComp />;
    };

    const insertSound = () => {
        if (validateData(chartMapData, 8)) {
            const $app = document.getElementById("supertable-sound");

            !!$app &&
                ReactDOM.render(
                    <CommonWrapper Comp={CarSoundproofingDom}></CommonWrapper>,
                    $app
                );
        }
    };

    // 9 座椅乘坐感
    const CarRideDom = useMemo(() => {
        const res = validateData(chartMapData, 9) as ICharts | false;

        if (res) {
            return <SupertestTab charts={charts} dataSource={res.chartData} />;
        }

        return <EmptyComp />;
    }, [chartMapData]);

    const insertRide = () => {
        if (validateData(chartMapData, 9)) {
            const $app = document.getElementById("supertable-ride");

            !!$app && ReactDOM.render(CarRideDom, $app);
        }
    };

    // 10 性能测试
    const CarPerformanceDom = useMemo(() => {
        const res = validateData(chartMapData, 10) as ICharts | false;

        if (res) {
            return <FillTable tableType="fillHeader" dataSource={res} />;
        }

        return <EmptyComp />;
    }, [chartMapData]);

    const insertPerformance = () => {
        if (validateData(chartMapData, 10)) {
            const $app = document.getElementById("supertable-performance");

            !!$app && ReactDOM.render(CarPerformanceDom, $app);
        }
    };

    // 11 加速表现
    const CarSpeedUpChartDom = () => {
        const res = validateData(chartMapData, 11) as ICharts | false;
        const [upKeys, setUpKeys] = useState<string[]>([]);

        if (res) {
            const { kindInfo } = kindData;
            const titles = [
                ["product"].concat(kindInfo.map((item) => item.title)),
            ];
            const dataSource = res.chartData.map((item) => [
                item.title,
                ...item.value.map((item) => Number(item)),
            ]);
            const extraKeys = (res.chartData as horizontalBarType[])[0]?.key;
            const extraDataArr = extraKeys.map((item, inx) => {
                const data = kindInfo.filter((i) => i.myid === item)?.[0];

                return data
                    ? {
                          name: data.title,
                          value: data.environment,
                          color: chartColorArr[inx],
                      }
                    : { name: "", value: "", color: chartColorArr[0] };
            });
            const data = titles.concat(dataSource as any);

            return (
                <a
                    className={"supertest-observer"}
                    href={`${host.c}/supertest/speedway`}
                    target="_blank"
                >
                    {res.chartName && (
                        <div className={styles["bar-title"]}>
                            {res.chartName}
                        </div>
                    )}
                    <ObserverWrapper
                        name="0to100Accelerate"
                        observerCallBack={(key) => setSuperTestKey(key)}
                        observerOnceCallBack={(key) =>
                            setUpKeys((prev) =>
                                !prev.includes(key) ? prev.concat(key) : prev
                            )
                        }
                    >
                        <BarGroup
                            id="0to100Accelerate"
                            width={786}
                            height={372}
                            dataSource={data}
                            visibleKeys={upKeys}
                        />
                    </ObserverWrapper>
                    <ChartExtraBar dataSource={extraDataArr} />
                </a>
            );
        }

        return <EmptyComp />;
    };

    const insertSpeedUp = () => {
        if (validateData(chartMapData, 11)) {
            const $app = document.getElementById("supertable-speed");

            !!$app &&
                ReactDOM.render(
                    <CommonWrapper
                        Comp={React.memo(CarSpeedUpChartDom)}
                    ></CommonWrapper>,
                    $app
                );
        }
    };

    // 12 剎車表現
    const CarBrakeChartDom = () => {
        const res = validateData(chartMapData, 12) as ICharts | false;
        const [upKeys, setUpKeys] = useState<string[]>([]);

        if (
            res &&
            kindData?.["100to0Brake"] &&
            kindData?.["100to0Brake"]?.length !== 0
        ) {
            const { kindInfo } = kindData;
            const titles = kindInfo.map((item) => item.title);
            const dataSource = res.chartData?.[0]?.value ?? [];

            return (
                <div className={"supertest-observer"}>
                    {res.chartName && (
                        <div className={styles["bar-title"]}>
                            {res.chartName}
                        </div>
                    )}
                    <ObserverWrapper
                        name="100to0Brake"
                        observerCallBack={(key) => setSuperTestKey(key)}
                        observerOnceCallBack={(key) =>
                            setUpKeys((prev) =>
                                !prev.includes(key) ? prev.concat(key) : []
                            )
                        }
                    >
                        <HorizontalBar
                            id="100to0Brake"
                            width={786}
                            height={324}
                            titles={titles}
                            dataSource={dataSource}
                            visibleKeys={upKeys}
                        />
                    </ObserverWrapper>
                    <BrakeCard dataSource={kindData["100to0Brake"]} />
                </div>
            );
        }

        return <EmptyComp />;
    };

    const insertBrake = () => {
        if (validateData(chartMapData, 12)) {
            const $app = document.getElementById("supertable-100km");

            !!$app &&
                ReactDOM.render(
                    <CommonWrapper Comp={CarBrakeChartDom}></CommonWrapper>,
                    $app
                );
        }
    };

    // x 操控表現
    const CarSpeedWayDom = useCallback(() => {
        const data = kindData?.["speedways"];

        if (data && data.length !== 0) {
            return (
                <div className={"supertest-observer"}  id="speed-ways">
                
                    <ObserverWrapper
                        name="speedway"
                        observerCallBack={(key) => setSuperTestKey(key)}
                    >
                        <Speedways id="speedway" dataSource={data} />
                    </ObserverWrapper>
                   
                </div>
            );
        }

        return <EmptyComp />;
    }, [kindData]);

    const insertSpeedWayDom = useCallback(() => {
        const $app =
            document.querySelector('[data-menu-item="滑輪測試"]') ||
            document.querySelector('[data-menu-item="加速表現"]');

        if (kindData?.["speedways"]) {
            !!$app &&
                ReactDOM.render(
                    <CommonWrapper Comp={CarSpeedWayDom}></CommonWrapper>,
                    $app
                );

            const moveDom = document.querySelector("#speed-ways");
            const referenceNode = document.querySelector(
                '[data-menu-sub-title="加速表現"]'
            );

            setTimeout(() => {
                if (referenceNode && referenceNode.parentNode && moveDom) {
                    referenceNode.parentNode.insertBefore(
                        moveDom,
                        referenceNode
                    );
                    
                    document.querySelector('#speed-ways-next')?.addEventListener('click', () => {
                        document.querySelector('#speed-ways-car')?.scrollTo(788, 0)
                    })

                    document.querySelector('#speed-ways-prev')?.addEventListener('click', () => {
                        document.querySelector('#speed-ways-car')?.scrollTo(-788, 0)
                    })
                }
            }, 0);
        }
    }, [kindData]);

    // // 30km/h震動曲線表現
    const CarShakeLine30 = () => {
        const res = validateData(chartMapData, 7) as ICharts | false;
        const data = shockData.filter((item) => item.type === 1);
        const [upKeys, setUpKeys] = useState<string[]>([]);

        if (res && data && data.length !== 0) {
            return (
                <div
                    className={"supertest-observer"}
                    style={{ marginTop: "20px" }}
                >
                    <ObserverWrapper
                        name="30kmVibrationComfort"
                        observerCallBack={(key) => setSuperTestKey(key)}
                        observerOnceCallBack={(key) =>
                            setUpKeys((prev) =>
                                !prev.includes(key) ? prev.concat(key) : []
                            )
                        }
                    >
                        <ShakeLine
                            id="30kmVibrationComfort"
                            title="30km/h震動曲線表現"
                            dataSource={data[0]}
                            visibleKeys={upKeys}
                        />
                    </ObserverWrapper>
                    <FixedTable title="30km/h震動數據" dataSource={res} />
                </div>
            );
        }

        return <EmptyComp />;
    };

    const insertLine30 = () => {
        if (validateData(chartMapData, 7)) {
            const $app1 = document.getElementById("supertable-30km");

            !!$app1 &&
                ReactDOM.render(
                    <CommonWrapper Comp={CarShakeLine30}></CommonWrapper>,
                    $app1
                );
        }
    };

    // 60km/h 震動曲線表現
    const CarShakeLine60 = () => {
        const res = validateData(chartMapData, 15) as ICharts | false;
        const data = shockData.filter((item) => item.type === 2);
        const [upKeys, setUpKeys] = useState<string[]>([]);

        if (res && data && data.length !== 0) {
            return (
                <div
                    className={"supertest-observer"}
                    style={{ marginTop: "20px" }}
                >
                    <ObserverWrapper
                        name="60kmVibrationComfort"
                        observerCallBack={(key) => setSuperTestKey(key)}
                        observerOnceCallBack={(key) =>
                            setUpKeys((prev) =>
                                !prev.includes(key) ? prev.concat(key) : []
                            )
                        }
                    >
                        <ShakeLine
                            id="60kmVibrationComfort"
                            title="60km/h震動曲線表現"
                            dataSource={data[0]}
                            visibleKeys={upKeys}
                        />
                    </ObserverWrapper>
                    <FixedTable title="60km/h震動數據" dataSource={res} />
                </div>
            );
        }

        return <EmptyComp />;
    };

    const insertLine60 = () => {
        if (validateData(chartMapData, 15)) {
            const $app = document.getElementById("supertable-60km");

            !!$app &&
                ReactDOM.render(
                    <CommonWrapper Comp={CarShakeLine60}></CommonWrapper>,
                    $app
                );
        }
    };

    const RightComp = () => {
        return (
            <>
                <Right />
                <FixedRank current={current} />
            </>
        );
    };

    const insertRight = useCallback(() => {
        const $app = document.getElementById("super-test-right");

        !!$app &&
            ReactDOM.render(
                <CommonWrapper Comp={RightComp}></CommonWrapper>,
                $app
            );
    }, [current]);

    const RightCompare = () => {
        return (
            <Compare
                dataSource={kindData.kindInfo}
                compareMyid={compareMyid}
                setCompare={setCompare}
            />
        );
    };

    const insertCompare = () => {
        const $app = document.getElementById("super-test-compare");

        !!$app &&
            ReactDOM.render(
                <CommonWrapper Comp={RightCompare}></CommonWrapper>,
                $app
            );
    };

    useLayoutEffect(() => {
        insertCar();
        insertDesign();
        insertADAS();
        insertSpace();
        insertSpaceImg();
        insertComfort();
        insertEnergy();
        insertSound();
        insertRide();
        insertPerformance();
        insertSpeedUp();
        insertBrake();
        insertSpeedWayDom();
        insertRight();
    }, [chartMapData, kindData]);

    useLayoutEffect(() => {
        insertLine30();
        insertLine60();
    }, [chartMapData, kindData, shockData]);

    useLayoutEffect(() => {
        insertCompare();
    }, [kindData, compareMyid]);

    useLayoutEffect(() => {
        insertRight();
    }, [current]);

    useLayoutEffect(() => {
        initTitle();
    }, []);

    return <div className={styles["supertest"]}></div>;
};

const Supertest = () => {
    return (
        <Provider>
            <Content />
        </Provider>
    );
};

const $app = document.getElementById("super-test");
!!$app && ReactDOM.render(<Supertest />, $app);
